import type { FC, SVGProps } from 'react';

export const TrustpilotLogo: FC<SVGProps<SVGSVGElement>> = ({
  width = 28,
  height = 28,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="24" height="24" rx="4" fill="#00B67A" />
    <path
      d="M12 4l2.09 6.26L20 10.24l-4.91 3.57L16.18 20 12 16.77 7.82 20l1.09-6.19L4 10.24l5.91-.02L12 4z"
      fill="white"
    />
  </svg>
);
